import React from "react";
import "../css/CHOPHeader.css";
import logo from "../img/ABC_logo.jpg";
import { isMobileOnly } from 'react-device-detect';

const CHOPHeader = (props) => {
  if(isMobileOnly) {
    return (
      <div className="CHOPHeader">
        <div className="columns">
          <div className="column">
            <img className="piculogo-mobile" src={logo} alt="PICU Logo" />
          </div>
          <div className="column bottom">
            {props.planLink}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="CHOPHeader">
        <div className="columns">
          <div className="column">
            <img className="piculogo" src={logo} alt="PICU Logo" />
          </div>
          <div className="column bottom">
            {props.planLink}
          </div>
        </div>
      </div>
    );
  }
};

export default CHOPHeader;
